<template>
  <!-- 账号密码注册 -->
  <div class="back">
    <div class="back-logo">
      <h1 class="logo-title">森威立拍</h1>
      <div class="heder-logo">
        <div class="top-2">
          <p
            class="code"
            @click="handlerEnroll"
            type="checkbox"
            :class="{ 'code-password': !isType }"
          >
            账号密码注册
          </p>
          <p
            class="code"
            @click="handlerPhone"
            :class="{ 'code-password': isType }"
          >
            验证码注册
          </p>
        </div>
      </div>
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <el-form-item :prop="!isType ? 'account' : 'phone'">
          <p>{{ !isType ? "手机号" : "手机号" }}</p>

          <el-tooltip
            v-if="!isType"
            class="item"
            effect="dark"
            content="设置后不可修改"
            placement="top"
          >
            <el-input
              type="text"
              v-model="ruleForm.account"
              auto-complete="off"
              placeholder="请设置手机号"
            ></el-input>
          </el-tooltip>

          <el-input
            type="text"
            v-else
            v-model="ruleForm.phone"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="!isType">
          <p>密码</p>
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="请设置6位以上登录密码"
            @input="handleInput('password')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="!isType">
          <p>确认密码</p>
          <el-input
            type="password"
            v-model="ruleForm.confirmPassword"
            placeholder="再次输入密码"
            auto-complete="off"
            @input="handleInput('confirmPassword')"
          ></el-input>
        </el-form-item>

        <el-form-item prop="code" class="fromItem" v-if="isType">
          <p>验证码</p>
          <div class="btn-code">
            <el-input
              type="text"
              v-model="ruleForm.code"
              placeholder="请输入验证码"
              auto-complete="off"
            ></el-input>
            <GetVerificationCode :ruleForm="ruleForm" />
            <!-- <el-button class="input-get" type="warning">获取验证码</el-button> -->
          </div>
        </el-form-item>

        <div>
          <div class="agree">
            <el-checkbox v-model="checked" class="checkbox"></el-checkbox>
            <p class="agreement">
              我已阅读并同意《
              <span class="agreement-text">会员服务协议</span>
              》和《
              <span class="policy">隐私政策</span>
              》
            </p>
          </div>
          <el-button @click="handleEnroll('ruleForm')" class="button-color"
            >注册</el-button
          >
          <div class="footer" @click="handleGoLogin">
            <p>已有账号？<span class="text"> 立即登录 </span></p>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import GetVerificationCode from "@/components/GetVerificationCode";
export default {
  data() {
    return {
      isType: false,
      checked: false,
      ruleForm: {
        phone: "", //账号
        password: "", // 密码
        confirmPassword: "", // 确认密码
        code: "", // 验证码
        account: "",
      },
      //rules前端验证
      rules: {
        account: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[345789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[345789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 12,
            message: "密码长度在6-12位之间",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
          {
            len: 4,
            message: "验证码长度为4位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    GetVerificationCode,
  },
  methods: {
    /**
     * 登录注册切换
     */
    handleGoLogin() {
      this.$store.commit("HANLE_IS_LOGIN_OR_REGISTER", 1);
    },
    handleInput(field) {
      if (field === "password") {
        this.ruleForm.password = this.ruleForm.password.replace(/\s/g, "");
      } else if (field === "confirmPassword") {
        this.ruleForm.confirmPassword = this.ruleForm.confirmPassword.replace(
          /\s/g,
          ""
        );
      }
    },
    // 账号注册
    handlerEnroll() {
      this.isType = false;
      this.handleClear();
      this.$refs.ruleForm.clearValidate();
    },
    // 手机号注册
    handlerPhone() {
      this.isType = true;
      this.handleClear();
      this.$refs.ruleForm.clearValidate();
    },
    handleClear() {
      this.ruleForm.phone = "";
      this.ruleForm.code = "";
      this.ruleForm.password = "";
      this.ruleForm.confirmPassword = "";
      this.ruleForm.account = "";
    },
    async handleEnroll(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message.error("请先同意用户协议");
            return;
          } else if (this.ruleForm.password !== this.ruleForm.confirmPassword) {
            this.$message.error("两次输入的密码不一致");
            return;
          }
          let _ruleForm;
          if (!this.isType) {
            _ruleForm = {
              account: this.ruleForm.account,
              password: this.ruleForm.password,
            };
          } else {
            _ruleForm = {
              phone: this.ruleForm.phone,
              code: this.ruleForm.code,
            };
          }
          await this.$store.dispatch("usreRegister", _ruleForm);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.back {
  // height: 100vh;
  // padding-top: 30px;
  background-color: rgb(241, 243, 248);
  box-sizing: border-box;

  .back-logo {
    position: relative;
    // width: 800px;
    // height: 700px;
    margin: 0 auto;
    padding: 40px;
    box-sizing: border-box;
    background: white;
    .logo-title {
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgb(164, 164, 164);
    }
    .heder-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #a4a4a4;
      width: 300px;
      margin: 0 auto;
      .top {
        margin-top: 50px;
      }
      .top-2 {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 58px 0 53px 0;
        width: 500px;
        .code {
          cursor: pointer;
          color: rgb(105, 105, 105);
          font-size: 20px;
          &:hover {
            color: black;
          }
        }
        .code-password {
          color: black !important;
          font-weight: bold;
        }
        .code-enroll {
          color: black;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.input {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  height: 400px;
  padding: 10px 0px;
  margin-bottom: 30px;
  p {
    text-align: left;
    font-size: 16px;
    padding: 10px 0px;
    margin-left: 3px;
  }
  .input-phone {
    margin-bottom: 15px;
  }
  .captcha {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .input-captcha {
      width: 320px;
      text-align: left;
    }
  }
}

.button-color {
  text-align: center;
  border: none;
  border-radius: 10px;
  background: linear-gradient(124deg, #f19234, #ec602b);
  cursor: pointer;
  width: 100%;
  height: 40px;
  margin-top: 19px;
  font-size: 14px;
  color: #fff;
  &:hover,
  &:focus {
    background: linear-gradient(124deg, #f19234, #ec602b) !important;
    color: #fff;
  }
}
.code {
  cursor: pointer;
  color: rgb(190, 180, 174);
  font-size: 20px;
  &:hover {
    color: black;
  }
}
.code-password {
  position: relative;
  color: black !important;
  font-weight: bold;
  z-index: 99;
  &::after {
    content: "";
    display: block;
    bottom: 2px;
    width: 100%;
    height: 5px;
    background-color: #f5723b;
    margin: -8px 0 0 0;
  }
}
.code-password:hover {
  color: black !important;
  font-weight: bold;
}
.fromItem {
  .btn-code {
    display: flex;
  }
}
.el-form {
  width: 360px;
  margin: 0 auto;
  .el-form-item {
    margin-bottom: 31px;
  }
}

// 协议
.agreementBtn {
  margin-top: 166px;
}
.agree {
  display: flex;
  justify-content: center;
  align-items: center;
  .agreement {
    font-size: 14px;
    margin-left: 6px;
    color: #555555;
    .agreement-text {
      color: #ec602b;
      cursor: pointer;
    }
    .policy {
      color: #ec602b;
      cursor: pointer;
    }
  }
}
.footer {
  margin-top: 10px;
  text-align: center;
  .text {
    color: rgb(231, 106, 42);
    font-size: 14px;
    cursor: pointer;
  }
}
:deep .el-input__inner {
  border-radius: 10px;
}
</style>